import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import authService from "./authService";

const initialState = {
  user: null,
  userFaq: null,
  userFaqCategory: null,
  verify: null,
  msgAttachment: null,
  data: null,
  getUserData: null,
  allListingData: null,
  isError: false,
  isSuccess: false,
  isLoading: false,
  chatIsLoading: false,
  isLoadingSmilar: false,
  message: "",
  allMessageData: null,
  // userSearch: null,
  SelectedMessageData: null,
  productSearch: null,
  favorite: null,
  getFavoriteData: null,
  isLoggedInData: null,
  profileChange: null,
  infoChange: null,
  changeAvailable: null,
  notification: null,
  view: null,
  similarProp: null,
  logout: null,
  ip: null,
};
//register user

export const register = createAsyncThunk(
  "user/register",
  async (user, thunkAPI) => {
    try {
      return await authService.registerService(user);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
//verification user

export const verification = createAsyncThunk(
  "user/sendverification",
  async (user, thunkAPI) => {
    try {
      return await authService.verificationService(user);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const newEmailVerification = createAsyncThunk(
  "user/reset/email",
  async (user, thunkAPI) => {
    try {
      return await authService.newEmailVerificationService(user);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const resetVerification = createAsyncThunk(
  "user/resetverification",
  async (user, thunkAPI) => {
    try {
      return await authService.resetVerificationService(user);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//login user

export const login = createAsyncThunk("user/login", async (user, thunkAPI) => {
  try {
    return await authService.loginService(user);
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});
//contact-us

export const contactUs = createAsyncThunk(
  "user/contactus",
  async (userData, thunkAPI) => {
    try {
      return await authService.contactUsService(userData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//isLogedin

export const isLoggedIn = createAsyncThunk(
  "user/isloggedin",
  async (user, thunkAPI) => {
    try {
      return await authService.isLoggedInService(user);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//addlisting
export const addListing = createAsyncThunk(
  "/user/property/add",
  async (homeData, thunkAPI) => {
    try {
      return await authService.addListingService(homeData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//editlisting
export const editListing = createAsyncThunk(
  "/user/property/update",
  async (homeData, thunkAPI) => {
    try {
      return await authService.editListingService(homeData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//getlisting
export const getListing = createAsyncThunk(
  "/user/property/get",
  async (id, thunkAPI) => {
    try {
      return await authService.getListingService(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//getUserlisting
export const getUserListing = createAsyncThunk(
  "/user/property/getuserdata",
  async (thunkAPI) => {
    try {
      return await authService.getUserListingService();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
//getAlllisting
export const getAllListing = createAsyncThunk(
  "/user/property/getalllisting",
  async (location, thunkAPI) => {
    try {
      return await authService.getAllListingService(location);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
//postSimilarProp
export const postSimilarProp = createAsyncThunk(
  "/user/property/postsimilarprop",
  async (homeType, thunkAPI) => { 
    try {
      return await authService.postSimilarPropService(homeType);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//getAllMessages
export const getAllMessages = createAsyncThunk(
  "/user/chat",
  async (thunkAPI) => {
    try {
      return await authService.getAllMessagesService();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//getSelectedMessage
export const getSelectedMessage = createAsyncThunk(
  "/user/chat/room",
  async (room, thunkAPI) => {
    try {
      return await authService.getSelectedMessageService(room);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// //getUser
// export const getUser = createAsyncThunk("/user/search", async (userName, thunkAPI) => {

//     try {
//         return await authService.getUserService(userName);
//     } catch (error) {
//         const message =
//             (error.response &&
//                 error.response.data &&
//                 error.response.data.message) ||
//             error.message ||
//             error.toString();
//         return thunkAPI.rejectWithValue(message);
//     }
// }
// );

//getlisting
export const getSearch = createAsyncThunk(
  "/user/s",
  async (currentPostion, thunkAPI) => {
    try {
      return await authService.getSearch(currentPostion);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// favorite
//post favorite

export const postFavorite = createAsyncThunk(
  "/user/favorite",
  async (userData, thunkAPI) => {
    try {
      return await authService.postFavoriteService(userData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const postMsgAttachment = createAsyncThunk(
  "/user/chat/upload",
  async (userData, thunkAPI) => {
    try {
      return await authService.postMsgAttachmentService(userData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//post favorite

export const getFavorite = createAsyncThunk(
  "/user/favorites",
  async (thunkAPI) => {
    try {
      return await authService.getFavoriteService();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// view
//post favorite

export const postView = createAsyncThunk(
  "/user/view",
  async (userdata, thunkAPI) => {
    try {
      return await authService.postViewService(userdata);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//post favorite

export const getView = createAsyncThunk("/user/view", async (thunkAPI) => {
  try {
    return await authService.getViewService();
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

//post profile pic

export const postProfilePic = createAsyncThunk(
  "/user/profile/pic",
  async (formData, thunkAPI) => {
    try {
      return await authService.postProfilePicService(formData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const postProfileInfo = createAsyncThunk(
  "/user/profile/info",
  async (formData, thunkAPI) => {
    try {
      return await authService.postProfileInfoService(formData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const postProfileEmail = createAsyncThunk(
  "/user/profile/email",
  async (formData, thunkAPI) => {
    try {
      return await authService.postProfileEmailService(formData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const postChangeAvailableSlice = createAsyncThunk(
  "/user/profile/available",
  async (formData, thunkAPI) => {
    try {
      return await authService.postChangeAvailableService(formData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const postProfilePass = createAsyncThunk(
  "/user/profile/pass",
  async (formData, thunkAPI) => {
    try {
      return await authService.postProfilePassService(formData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const postPasswordReset = createAsyncThunk(
  "/user/password/reset",
  async (formData, thunkAPI) => {
    try {
      return await authService.postPasswordResetService(formData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const postVerifyCode = createAsyncThunk(
  "/user/verify/code",
  async (formData, thunkAPI) => {
    try {
      return await authService.postVerifyCodeService(formData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const postReportPost = createAsyncThunk(
  "/user/reportpost",
  async (formData, thunkAPI) => {
    try {
      return await authService.postReportPostService(formData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//getNotification
export const getNotification = createAsyncThunk(
  "/user/notification",
  async (thunkAPI) => {
    try {
      return await authService.getNotificationService();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// logout
export const logoutSlice = createAsyncThunk("/api/logout", async (thunkAPI) => {
  try {
    return await authService.logoutService();
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

// delete home
export const deleteHomeSlice = createAsyncThunk(
  "/user/property/delete",
  async (userData, thunkAPI) => {
    try {
      return await authService.deleteHomeService(userData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const deleteAccountSlice = createAsyncThunk(
  "/user/deleteaccount",
  async (userData, thunkAPI) => {
    try {
      return await authService.deleteAccountService(userData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const ipSlice = createAsyncThunk("/user/ip", async (thunkAPI) => {
  try {
    return await authService.ipService();
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const postEmailSlice = createAsyncThunk(
  "/user/subEmail",
  async (userData, thunkAPI) => {
    try {
      return await authService.postEmailService(userData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getFaqWithId = createAsyncThunk(
  "/user/faq/get/id",
  async (id, thunkAPI) => {
    try {
      return await authService.getFaqWithIdService(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getFaqCategoryUser = createAsyncThunk(
  "/user/faq/category/get",
  async (thunkAPI) => {
    try {
      return await authService.getFaqCategoryService();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    reset: (state) => {
      state.message = "";
      state.infoChange = "";
      state.changeAvailable = "";
      state.user = null;
      state.verify = null;
      state.logout = null;
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;

      state.chatIsLoading = false;
      state.msgAttachment = null;
      state.allListingData = null;
    },
    resetDetail: (state) => {
      state.isLoading = true;
      state.data = null;
      state.isError = false;
      state.isSuccess = false;
      state.userFaq = null;
      state.userFaqCategory = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(register.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(register.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.user = action.payload;
        state.message = action.payload.message;
      })
      .addCase(register.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.user = null;
      })

      .addCase(getFaqWithId.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getFaqWithId.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.userFaq = action.payload;
      })
      .addCase(getFaqWithId.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getFaqCategoryUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getFaqCategoryUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.userFaqCategory = action.payload;
      })
      .addCase(getFaqCategoryUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isErrorAdmin = true;
        state.message = action.payload;
      })

      // sendverification
      .addCase(verification.pending, (state) => {
        // state.isLoading = true;
      })
      .addCase(verification.fulfilled, (state, action) => {
        // state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload.message;
      })
      .addCase(verification.rejected, (state, action) => {
        // state.isLoading = false;
        state.isError = true;
        state.message = action.payload.message;
      })
      // sendverification
      .addCase(newEmailVerification.pending, (state) => {
        // state.isLoading = true;
      })
      .addCase(newEmailVerification.fulfilled, (state, action) => {
        // state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload.message;
      })
      .addCase(newEmailVerification.rejected, (state, action) => {
        // state.isLoading = false;
        state.isError = true;
        state.message = action.payload.message;
      })
      // reset verification
      .addCase(resetVerification.pending, (state) => {
        // state.isLoading = true;
      })
      .addCase(resetVerification.fulfilled, (state, action) => {
        // state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload.message;
      })
      .addCase(resetVerification.rejected, (state, action) => {
        // state.isLoading = false;
        state.isError = true;
        state.message = action.payload.message;
      })
      // login
      .addCase(login.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.user = action.payload;
        state.message = action.payload.message;
      })
      .addCase(login.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.user = null;
      })
      // contact - us
      .addCase(contactUs.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(contactUs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(contactUs.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      // isloggedin
      .addCase(isLoggedIn.pending, (state) => {
        // state.isLoading = true;
      })
      .addCase(isLoggedIn.fulfilled, (state, action) => {
        // state.isLoading = false;
        // state.isSuccess = true;
        state.isLoggedInData = action.payload;
      })
      .addCase(isLoggedIn.rejected, (state, action) => {
        // state.isLoading = false;
        // state.isError = true;
        // state.message = action.payload;
        state.isLoggedInData = null;
      })

      //addListing
      .addCase(addListing.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addListing.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload.message;
      })
      .addCase(addListing.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      //editListing
      .addCase(editListing.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(editListing.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload.message;
      })
      .addCase(editListing.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      //getlisting

      .addCase(getListing.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getListing.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = action.payload;
      })
      .addCase(getListing.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      //getUserListing

      .addCase(getUserListing.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getUserListing.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.getUserData = action.payload;
      })
      .addCase(getUserListing.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      //getAllListing

      .addCase(getAllListing.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllListing.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.allListingData = action.payload;
      })
      .addCase(getAllListing.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      //postSimilarProp

      .addCase(postSimilarProp.pending, (state) => {
        // state.isLoading = true;
        state.isLoadingSmilar = true;
      })
      .addCase(postSimilarProp.fulfilled, (state, action) => {
        // state.isLoading = false;
        state.isLoadingSmilar = false;
        state.isSuccess = true;
        state.similarProp = action.payload;
      })
      .addCase(postSimilarProp.rejected, (state, action) => {
        // state.isLoading = false;
        state.isLoadingSmilar = false;
        state.isError = true;
        state.message = action.payload;
      })

      //getAllMessages

      .addCase(getAllMessages.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllMessages.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.allMessageData = action.payload;
      })
      .addCase(getAllMessages.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      //getSelectedMessage

      .addCase(getSelectedMessage.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSelectedMessage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.SelectedMessageData = action.payload;
      })
      .addCase(getSelectedMessage.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      // //getUser

      // .addCase(getUser.pending, (state) => {
      //     // state.isLoading = true;
      // })
      // .addCase(getUser.fulfilled, (state, action) => {
      //     // state.isLoading = false;
      //     state.isSuccess = true;
      //     state.userSearch = action.payload;

      // })
      // .addCase(getUser.rejected, (state, action) => {
      //     // state.isLoading = false;
      //     state.isError = true;
      //     state.message = action.payload.message;

      // })

      //getSearch

      .addCase(getSearch.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSearch.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.productSearch = action.payload;
      })
      .addCase(getSearch.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload.message;
      })

      //favorite

      //postFavorite

      .addCase(postFavorite.pending, (state) => {
        // state.isLoading = true;
      })
      .addCase(postFavorite.fulfilled, (state, action) => {
        // state.isLoading = false;
        state.isSuccess = true;
        state.favorite = action.payload;
      })
      .addCase(postFavorite.rejected, (state, action) => {
        // state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      //post msg attachment

      .addCase(postMsgAttachment.pending, (state) => {
        state.chatIsLoading = true;
      })
      .addCase(postMsgAttachment.fulfilled, (state, action) => {
        state.chatIsLoading = false;
        state.isSuccess = true;
        state.msgAttachment = action.payload;
      })
      .addCase(postMsgAttachment.rejected, (state, action) => {
        state.chatIsLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      // postEmailSlice
      .addCase(postEmailSlice.pending, (state) => {
        // state.isLoading = true;
      })
      .addCase(postEmailSlice.fulfilled, (state, action) => {
        // state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload.message;
      })
      .addCase(postEmailSlice.rejected, (state, action) => {
        // state.isLoading = false;
        state.isError = true;
        state.message = action.payload.message;
      })

      //getFavorite

      .addCase(getFavorite.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getFavorite.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.getFavoriteData = action.payload;
      })
      .addCase(getFavorite.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      //profile

      .addCase(postProfilePic.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(postProfilePic.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.profileChange = action.payload;
        state.message = action.payload.message;
      })
      .addCase(postProfilePic.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      .addCase(postProfileInfo.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(postProfileInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.infoChange = action.payload;
        state.message = action.payload.message;
      })
      .addCase(postProfileInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      .addCase(postProfileEmail.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(postProfileEmail.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.infoChange = action.payload.message;
      })
      .addCase(postProfileEmail.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      .addCase(postChangeAvailableSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(postChangeAvailableSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.changeAvailable = action.payload.message;
      })
      .addCase(postChangeAvailableSlice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      .addCase(postProfilePass.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(postProfilePass.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.infoChange = action.payload.message;
      })
      .addCase(postProfilePass.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      // passwors reset
      .addCase(postPasswordReset.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(postPasswordReset.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload.message;
        state.user = action.payload;
      })
      .addCase(postPasswordReset.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      // Verify Code
      .addCase(postVerifyCode.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(postVerifyCode.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload.message;
        state.verify = action.payload;
      })
      .addCase(postVerifyCode.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })

      //notification
      .addCase(getNotification.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getNotification.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.notification = action.payload;
      })
      .addCase(getNotification.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload.message;
      })
      //view
      .addCase(getView.pending, (state) => {
        // state.isLoading = true;
      })
      .addCase(getView.fulfilled, (state, action) => {
        // state.isLoading = false;
        // state.isSuccess = true;
        state.view = action.payload;
      })
      .addCase(getView.rejected, (state, action) => {
        // state.isLoading = false;
        // state.isError = true;
        // state.message = action.payload;
      })

      //logOut
      .addCase(logoutSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(logoutSlice.fulfilled, (state) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.logout = true;
      })
      .addCase(logoutSlice.rejected, (state) => {
        state.isLoading = false;
      })

      //Delete home
      .addCase(deleteHomeSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteHomeSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload.message;
      })
      .addCase(deleteHomeSlice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload.message;
      })
      //Delete Account
      .addCase(deleteAccountSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAccountSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.message = action.payload;
      })
      .addCase(deleteAccountSlice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(ipSlice.pending, (state) => {
        // state.isLoading = true;
      })
      .addCase(ipSlice.fulfilled, (state, action) => {
        // state.isLoading = false;
        // state.isSuccess = true;
        state.ip = action.payload;
      })
      .addCase(ipSlice.rejected, (state, action) => {
        // state.isLoading = false;
        // state.isError = true;
        // state.message = action.payload.message;
      });
  },
});

export const { reset } = authSlice.actions;

export default authSlice.reducer;
